import React, { useState } from 'react';
import i18n from 'i18next';

import { Button, Input } from '@airbus/components-react';
import { Application, IAppsVersionsData } from '../../../../models/AppModels';

import classes from './CardOverview.module.css';
import ArrowCircleIcon from '../../../icons/ArrowCircleIcon';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import CancellationModal, { CancellationModalType } from '../../CancellationModal';
import DialogInfo from '../../../../shared/components/DialogInfo';

export type ChosenApplication = Omit<Application, 'ife_app_version'> & {
    chosenAppVersion: IAppsVersionsData;
};

type Props = {
    chosenApplications: ChosenApplication[];
    commonClasses: {
        readonly [key: string]: string;
    };
    canDeploy: boolean;
    onDeploy: () => void;
    syncTitle: string;
    onSyncTitleChange: (syncTitle: string) => void;
    modalProps: CancellationModalType;
    cancelPlannedDeliveryBundles: () => void;
};

const CardOverview = ({
    commonClasses,
    canDeploy,
    onDeploy,
    syncTitle,
    onSyncTitleChange,
    modalProps,
    cancelPlannedDeliveryBundles
}: Props) => {
    const [optionType, setOptionType] = useState<'4G' | 'SatCom'>('4G');
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleValidate = () => {
        onDeploy();
        setIsOpen(false);
    };

    return (
        <div className={commonClasses.container_card}>
            <div className={commonClasses.container_header}>
                <p className={commonClasses.container_title}>{i18n.t('deployment.schedule.overview_deploy_title')}</p>
                <p className={commonClasses.container_subtitle} style={{ visibility: 'hidden' }}>
                    -
                </p>
                <div className={commonClasses.line} />
            </div>
            <div className={commonClasses.container_body}>
                <div className={classes.sync_title_container}>
                    <p className={classes.sync_title}>{i18n.t('deployment.schedule.overview_deploy_sync_title')}</p>
                    <div className={classes.sync_title_input_container}>
                        <Input
                            value={syncTitle}
                            className={classes.sync_title_input}
                            placeholder={i18n.t('deployment.schedule.overview_deploy_sync_placeholder_title')}
                            onChange={(event, value) => onSyncTitleChange(value)}
                        />
                    </div>
                </div>
                <div className={classes.option_container}>
                    <p className={classes.sync_data_title}>{i18n.t('deployment.schedule.overview_deploy_options_title')}</p>
                    <div className={classes.option_toggles_container}>
                        <ToggleButtonGroup
                            className={classes.option_toggle}
                            color="primary"
                            value={optionType}
                            exclusive
                            fullWidth
                            onChange={(e, v) => {
                                if (v !== null) {
                                    setOptionType(v);
                                }
                            }}
                            aria-label="Sync type">
                            <ToggleButton value="4G">4G</ToggleButton>
                            <ToggleButton value="SatCom">SatCom</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                </div>
                <DialogInfo open={isOpen} setOpen={setIsOpen} title={'Validation'} onValidate={handleValidate}>
                    <p>{i18n.t('deployment.schedule.confirm_message_to_launch_deployment')}</p>
                </DialogInfo>
                <div className={classes.deploy_button}>
                    <Button
                        disabled={!canDeploy || syncTitle === ''}
                        variant="primary"
                        data-testid="launch-button"
                        icon={<ArrowCircleIcon />}
                        onClick={() => {
                            setIsOpen(true);
                        }}>
                        Launch deployment
                    </Button>
                    <CancellationModal modalProps={modalProps} cancelPlannedDeliveryBundles={cancelPlannedDeliveryBundles} />
                </div>
            </div>
        </div>
    );
};

export default CardOverview;
